import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Plugs, ListBullets, SquaresFour, Wrench } from '@phosphor-icons/react';
import { ModuleShell, ModuleSubnav } from '../../components/module-ui';
import ConnectFlowPage from './pages/ConnectFlowPage';
import RegistryPage from './pages/RegistryPage';
import ClientWorkspacePage from './pages/ClientWorkspacePage';
import ScreensPreviewPage from './pages/ScreensPreviewPage';
import SettingsPage from './pages/SettingsPage';
import { SupportingToolsProvider, STANDARD } from './SupportingToolsContext';
import './supportingTools.css';

const subnavFor = (basePath) => [
  { to: `${basePath}/connect`, label: 'Connect', icon: Plugs, end: true },
  { to: `${basePath}/registry`, label: 'Registry', icon: ListBullets },
];

// Mounted twice: as Supporting Tools and, with the LIVE config, as Supporting
// Tools Live. Both run the same screens; the config says where it is mounted.
function SupportingToolsLayout({ config = STANDARD }) {
  const { basePath, title, subtitle, variant } = config;
  const location = useLocation();
  const navigate = useNavigate();
  const isClientWorkspace = location.pathname.includes('/clients/');
  const isScreensPreview = location.pathname.includes('/screens');
  const isSettings = location.pathname.endsWith('/settings');

  return (
    <SupportingToolsProvider value={config}>
    <ModuleShell
      title={isClientWorkspace ? null : title}
      subtitle={isClientWorkspace ? null : subtitle}
      icon={Wrench}
      hideHeader={isClientWorkspace}
      headerActions={
        !isClientWorkspace && !isScreensPreview && !isSettings ? (
          <button
            type="button"
            onClick={() => navigate(`${basePath}/screens`)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 14px',
              borderRadius: '8px',
              fontSize: '13px',
              fontWeight: '500',
              border: '1px solid #E5E7EB',
              cursor: 'pointer',
              color: '#4B5563',
              background: 'white',
            }}
            data-testid="supporting-tools-all-screens-link"
          >
            <SquaresFour size={16} />
            All Screens
          </button>
        ) : null
      }
      subnav={
        isClientWorkspace ? null : (
          <ModuleSubnav items={subnavFor(basePath)} aria-label={`${title} navigation`} />
        )
      }
    >
      <div className="st-scope">
      <Routes>
        <Route index element={<Navigate to="connect" replace />} />
        <Route path="connect" element={<ConnectFlowPage />} />
        <Route path="registry" element={<RegistryPage />} />
        <Route path="clients/:connectionId" element={<ClientWorkspacePage />} />
        <Route path="screens" element={<ScreensPreviewPage />} />
        <Route path="screens/:moduleKey" element={<ScreensPreviewPage />} />
        {variant === 'standard' && <Route path="settings" element={<SettingsPage />} />}
      </Routes>
      </div>
    </ModuleShell>
    </SupportingToolsProvider>
  );
}

export default SupportingToolsLayout;
